import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Component } from 'react';
import CrashScreen from './crash-screen';
import { reportCrash } from './report-crash';
class AppCrashBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleReset = () => {
            window.location.reload();
        };
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('App crashed:', error, errorInfo);
        reportCrash({
            app: this.props.app,
            error,
            kind: 'react_caught',
            componentStack: errorInfo.componentStack,
        });
    }
    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }
    render() {
        if (this.state.hasError) {
            return _jsx(CrashScreen, { onReset: this.handleReset });
        }
        return _jsx(_Fragment, { children: this.props.children });
    }
}
export default AppCrashBoundary;
